import React, { Component, createRef } from 'react';
import { bool, func, object, node, number, shape, string, arrayOf } from 'prop-types';
import classNames from 'classnames';
import { useHistory } from 'react-router-dom';
import CloseIcon from '../../TopbarContainer/Topbar/CloseIcon';

import { useRouteConfiguration } from '../../../context/routeConfigurationContext';
import { FormattedMessage, useIntl, intlShape } from '../../../util/reactIntl';

import css from './SearchFiltersMobile.module.css';

class SearchFiltersMobileComponent extends Component {
  constructor(props) {
    super(props);
    this.state = { isFiltersOpenOnMobile: false };

    this.dropdownRef = createRef(); // Reference for detecting clicks outside
    this.filterButtonRef = createRef(); // Reference for the filter button
    this.toggleFilters = this.toggleFilters.bind(this);
    this.closeFilters = this.closeFilters.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside(event) {
    if (
      this.dropdownRef.current &&
      !this.dropdownRef.current.contains(event.target) &&
      event.target !== this.filterButtonRef.current
    ) {
      this.closeFilters(); // Close the dropdown if clicked outside
    }
  }

  toggleFilters(event) {
    event.stopPropagation(); // Prevent the click from propagating to handleClickOutside
    this.setState(prevState => ({
      isFiltersOpenOnMobile: !prevState.isFiltersOpenOnMobile,
    }));
  }

  closeFilters() {
    this.setState({ isFiltersOpenOnMobile: false });
  }

  render() {
    const {
      rootClassName,
      className,
      children,
      listingsAreLoaded,
      sortByComponent,
      saveSearchComponent,
      resultsCount,
      formattedFilters,
      searchInProgress,
      intl,
    } = this.props;

    const classes = classNames(rootClassName || css.root, className);

    // const resultsFound = (
    //   <FormattedMessage id="SearchFiltersMobile.foundResults" values={{ count: resultsCount }} />
    // );
    const noResults = (
      <>
        <FormattedMessage id="SearchFiltersMobile.noResults" />
        <button className={css.resetAllButton} onClick={this.props.resetAll}>
          <FormattedMessage id="SearchFiltersMobile.resetAll" />
        </button>
      </>
    );
    const loadingResults = <FormattedMessage id="SearchFiltersMobile.loadingResults" />;

    const SortByIcon = props => {
      const classes = classNames(css.icon, props.className);
      // extra small arrow head (down)
      return (
        <svg className={classes} width="8" height="5" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M3.764 4.236c.131.13.341.13.472 0l2.666-2.667a.333.333 0 10-.471-.471L4 3.528l-2.43-2.43a.333.333 0 10-.471.471l2.665 2.667z"
            fill="#4A4A4A"
            stroke="#4A4A4A"
            fillRule="evenodd"
          />
        </svg>
      );
    };
    const iconArrowClassName = this.state.isFiltersOpenOnMobile ? css.iconArrowAnimation : null;

    return (
      <div className={classes}>
        {formattedFilters ? (
          <>
            <h3>
              {resultsCount} results for {formattedFilters}:
            </h3>
          </>
        ) : (
          <h3>All Listings:</h3>
        )}

        <div className={css.buttons}>
          <button
            ref={this.filterButtonRef}
            className={classNames(css.filtersButton, {
              [css.filtersButtonActive]: this.state.isFiltersOpenOnMobile,
            })}
            onClick={this.toggleFilters}
          >
            Filter
            <SortByIcon className={iconArrowClassName} />
            {this.props.selectedFiltersCount > 0 ? (
              <button
                type="button"
                style={{ marginLeft: '14px' }}
                className={css.filtersButton}
                onClick={evt => {
                  evt.stopPropagation();
                  this.props.resetAll();
                }}
              >
                <CloseIcon className={css.closeIcon} />
              </button>
            ) : null}
          </button>
          <div className={css.rightButtons}>
            {saveSearchComponent}
            {sortByComponent}
          </div>
        </div>

        <div className={css.dropdownWrapper} ref={this.dropdownRef}>
          {this.state.isFiltersOpenOnMobile && (
            <div className={css.dropdownMenu}>
              <div className={css.filtersWrapper}>{children}</div>
              <div className={css.dropdownFooter}>
                <button className={css.showListingsButton} onClick={this.closeFilters}>
                  <FormattedMessage
                    id="SearchFiltersMobile.showListings"
                    values={{ count: resultsCount }}
                  />
                </button>
                <button className={css.resetAllButton} onClick={this.props.resetAll}>
                  <FormattedMessage id="SearchFiltersMobile.resetAll" />
                </button>
              </div>
            </div>
          )}
        </div>

        <div className={css.searchResultSummary}>
          {listingsAreLoaded && resultsCount === 0 ? noResults : null}
          {searchInProgress ? loadingResults : null}
        </div>
      </div>
    );
  }
}

SearchFiltersMobileComponent.defaultProps = {
  rootClassName: null,
  className: null,
  resultsCount: null,
  searchInProgress: false,
  saveSearchComponent: null,
};

SearchFiltersMobileComponent.propTypes = {
  rootClassName: string,
  className: string,
  listingsAreLoaded: bool.isRequired,
  resultsCount: number,
  searchInProgress: bool,
  resetAll: func.isRequired,
  saveSearchComponent: node,
  intl: intlShape.isRequired,
};

const SearchFiltersMobile = props => {
  const routeConfiguration = useRouteConfiguration();
  const intl = useIntl();
  const history = useHistory();

  return (
    <SearchFiltersMobileComponent
      routeConfiguration={routeConfiguration}
      intl={intl}
      history={history}
      {...props}
    />
  );
};

export default SearchFiltersMobile;
